import { formatChildPath } from '../../../../../helpers/formatPathnameToSchoolSlug';
import { SchoolPageTab } from '../SchoolPageTabs';

export const getSelectedTabIndex = ({
  tabs,
  childPath,
}: {
  tabs: SchoolPageTab[];
  childPath: string | undefined;
}): number => {
  const path = formatChildPath(childPath);
  if (path === '/') {
    return tabs.findIndex((tab) => tab.title === 'Overview');
  }
  return tabs.findIndex((tab) => tab.fullPath.includes(path));
};
